import * as React from 'react';
import { Option, Select } from '@bringg/react-components';
import Spinner from '../spinner/spinner';
import './routes-select.scss';
import { observer } from 'mobx-react-lite';

export interface RouteProps {
	id: number;
	title: string;
	color: string;
	isLoading?: boolean;
}
interface Props {
	routes: RouteProps[];
	selectedValue: number;
	style?: React.CSSProperties;
	onSelect: (id: number) => void;
}

const RoutesSelect = (props: Props) => {
	const { routes = [], style, onSelect, selectedValue } = props;

	return (
		<Select
			className="routes-select"
			data-test-id="routes-select"
			dropdownClassName="routes-select-dropdown"
			placeholder="No Route"
			showSearch
			filterOption={(searchValue, option) => option.name.toLowerCase().includes(searchValue.toLowerCase())}
			style={style}
			onSelect={onSelect}
			value={selectedValue}
			getPopupContainer={() => document.querySelector('.resequence-task')}
		>
			{routes.map(({ id, title, color, isLoading }) => (
				<Option
					key={id.toString()}
					value={id}
					name={title}
					disabled={isLoading}
					className={`routes-select-option ${isLoading ? 'route-select-loading' : ''}`}
					data-test-id="routes-select-option"
				>
					<div className="route-select-option-name">
						<div className="dot" style={{ background: color }} />
						<div className="title">{title}</div>
					</div>
					{isLoading && <Spinner />}
				</Option>
			))}
			)
		</Select>
	);
};

export default observer(RoutesSelect);
